/**
 * Basic QuestionnaireElement, normally no element will be created from this
 */
export class QuestionnaireElement {
    protected elementtype: String = '';
    protected position = 0;
    protected active: Boolean = false;

    public constructor() { }

    public setElementType(elementtype: String) { this.elementtype = elementtype; }
    public getElementType() { return this.elementtype; }
    public setPosition(position) { this.position = position; }
    public getPosition() { return this.position; }
    public setActive(active: Boolean) { this.active = active; }
    public isActive() { return this.active; }
}

/**
 * Element only Headline
 */
export class QuestionnaireElementHeadline extends QuestionnaireElement {
    protected name: String = '';
    protected headline = {};

    public setName(name: String) { this.name = name; }
    public getName() { return this.name; }

    public setHeadline(headline: String, language: String) {
        this.headline[language.toString()] = headline;
    }

    public getHeadline(language: String) {
        return this.headline[language.toString()];
    }
}

/**
 * Element YesNo
 */
export class QuestionnaireElementYesNo extends QuestionnaireElement {
    protected name: String = '';
    protected label: String = '';
    protected values = [];
    protected question = {};
    protected answers = {};
    protected required: Boolean = false;

    public setName(name: String) { this.name = name; }
    public getName() { return this.name; }

    public setLabel(label: String) { this.label = label; }
    public getLabel() { return this.label; }

    public setValues(values) { this.values = values; }
    public getValues() { return this.values; }

    public setRequired(required: Boolean) { this.required = required; }
    public isRequired() { return this.required; }

    public setQuestion(question: String, language: String) {
        this.question[language.toString()] = question;
    }

    public getQuestion(language: String) {
        return this.question[language.toString()];
    }

    public setAnswers(answers, language: String) {
        this.answers[language.toString()] = answers;
    }

    public getAnswers(language: String) {
        return this.answers[language.toString()];
    }
}



export class QuestionnaireElementSlider extends QuestionnaireElement {
    protected name: String = '';
    protected label: String = '';
    protected values = {};
    protected question = {};
    protected answers = {};
    protected required: Boolean = false;

    public setName(name: String) { this.name = name; }
    public getName() { return this.name; }

    public setLabel(label: String) { this.label = label; }
    public getLabel() { return this.label; }

    public setValues(values) { this.values = values; }
    public getValues() { return this.values; }

    public setRequired(required: Boolean) { this.required = required; }
    public isRequired() { return this.required; }

    public setQuestion(question: String, language: String) {
        this.question[language.toString()] = question;
    }

    public getQuestion(language: String) {
        return this.question[language.toString()];
    }

    public setAnswers(answers, language: String) {
        this.answers[language.toString()] = answers;
    }

    public getAnswers(language: String) {
        return this.answers[language.toString()];
    }
}

export class QuestionnaireElementSingleChoice extends QuestionnaireElement {
    protected name: String = '';
    protected label: String = '';
    protected values = [];
    protected question = {};
    protected answers = {};
    protected required: Boolean = false;

    public setName(name: String) { this.name = name; }
    public getName() { return this.name; }

    public setLabel(label: String) { this.label = label; }
    public getLabel() { return this.label; }

    public setValues(values) { this.values = values; }
    public getValues() { return this.values; }

    public setRequired(required: Boolean) { this.required = required; }
    public isRequired() { return this.required; }

    public setQuestion(question: String, language: String) {
        this.question[language.toString()] = question;
    }

    public getQuestion(language: String) {
        return this.question[language.toString()];
    }

    public setAnswers(answers, language: String) {
        this.answers[language.toString()] = answers;
    }

    public getAnswers(language: String) {
        return this.answers[language.toString()];
    }
}


export class QuestionnaireElementTextDate extends QuestionnaireElement {
    protected name: String = '';
    protected label: String = '';
    protected values = [];
    protected question = {};
    protected answers = {};
    protected required: Boolean = false;

    public setName(name: String) { this.name = name; }
    public getName() { return this.name; }

    public setLabel(label: String) { this.label = label; }
    public getLabel() { return this.label; }

    public setValues(values) { this.values = values; }
    public getValues() { return this.values; }

    public setRequired(required: Boolean) { this.required = required; }
    public isRequired() { return this.required; }

    public setQuestion(question: String, language: String) {
        this.question[language.toString()] = question;
    }

    public getQuestion(language: String) {
        return this.question[language.toString()];
    }

    public setAnswers(answers, language: String) {
        this.answers[language.toString()] = answers;
    }

    public getAnswers(language: String) {
        return this.answers[language.toString()];
    }
}

export class QuestionnaireElementMultipleChoice extends QuestionnaireElement {
    protected name: String = '';
    protected label: String = '';
    protected values = [];
    protected question = {};
    protected answers = {};
    protected required: Boolean = false;

    public setName(name: String) { this.name = name; }
    public getName() { return this.name; }

    public setLabel(label: String) { this.label = label; }
    public getLabel() { return this.label; }

    public setValues(values) { this.values = values; }
    public getValues() { return this.values; }

    public setRequired(required: Boolean) { this.required = required; }
    public isRequired() { return this.required; }

    public setQuestion(question: String, language: String) {
        this.question[language.toString()] = question;
    }

    public getQuestion(language: String) {
        return this.question[language.toString()];
    }

    public setAnswers(answers, language: String) {
        this.answers[language.toString()] = answers;
    }

    public getAnswers(language: String) {
        return this.answers[language.toString()];
    }
}


export class QuestionnaireElementTextString extends QuestionnaireElement {
    protected name: String = '';
    protected label: String = '';
    protected values = [];
    protected question = {};
    protected answers = {};
    protected required: Boolean = false;

    public setName(name: String) { this.name = name; }
    public getName() { return this.name; }

    public setLabel(label: String) { this.label = label; }
    public getLabel() { return this.label; }

    public setValues(values) { this.values = values; }
    public getValues() { return this.values; }

    public setRequired(required: Boolean) { this.required = required; }
    public isRequired() { return this.required; }

    public setQuestion(question: String, language: String) {
        this.question[language.toString()] = question;
    }

    public getQuestion(language: String) {
        return this.question[language.toString()];
    }

    public setAnswers(answers, language: String) {
        this.answers[language.toString()] = answers;
    }

    public getAnswers(language: String) {
        return this.answers[language.toString()];
    }
}

export class QuestionnaireElementTextArea extends QuestionnaireElement {
    protected name: String = '';
    protected label: String = '';
    protected values = [];
    protected question = {};
    protected answers = {};
    protected required: Boolean = false;

    public setName(name: String) { this.name = name; }
    public getName() { return this.name; }

    public setLabel(label: String) { this.label = label; }
    public getLabel() { return this.label; }

    public setValues(values) { this.values = values; }
    public getValues() { return this.values; }

    public setRequired(required: Boolean) { this.required = required; }
    public isRequired() { return this.required; }

    public setQuestion(question: String, language: String) {
        this.question[language.toString()] = question;
    }

    public getQuestion(language: String) {
        return this.question[language.toString()];
    }

    public setAnswers(answers, language: String) {
        this.answers[language.toString()] = answers;
    }

    public getAnswers(language: String) {
        return this.answers[language.toString()];
    }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/models/questionnaire-element.ts